
    <div class="lg:hidden">
        <div *ngIf="isMobileOpen" class="fixed inset-0 z-50">
            <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" (click)="closeMobile()"></div>
            <aside
                class="absolute left-0 top-0 bottom-0 flex flex-col w-72 max-w-full bg-[color:var(--card)] text-[color:var(--foreground)] border-r border-[color:var(--border)] shadow-[0_20px_50px_rgba(15,23,42,0.18)] transform transition-transform duration-200 ease-out"
                [class.translate-x-0]="isMobileOpen"
                [class.-translate-x-full]="!isMobileOpen"
                (click)="$event.stopPropagation()"
            >
	                <div class="flex items-center justify-between h-16 px-5 border-b border-[color:var(--border)]">
	                    <a routerLink="/" class="flex items-center gap-3">
	                        <div class="h-10 px-3 flex items-center">
	                            <img [src]="logoSrc" alt="nibni" class="h-10 w-auto object-contain select-none" />
	                        </div>
	                    </a>
                    <button type="button" class="rounded-md p-2 text-[color:var(--text-subtle)] hover:bg-[color:var(--hover)] transition" (click)="closeMobile()">
                        <lucide-icon name="x" class="h-5 w-5"></lucide-icon>
                        <span class="sr-only">Close menu</span>
                    </button>
                </div>
                <nav class="custom-scrollbar min-h-0 flex-1 px-4 py-4 space-y-2 overflow-y-auto overscroll-contain">
                    <ng-container *ngFor="let item of navigation; let idx = index">
                        <!-- Collapsible dropdown (e.g. "More") -->
                        <ng-container *ngIf="isCollapsible(item)">
                            <button
                                type="button"
                                (click)="toggleGroup(item.name)"
                                [attr.aria-expanded]="isGroupExpanded(item.name)"
                                [class.mt-6]="idx > 0"
                                [class.pt-4]="idx > 0"
                                [class.border-t]="idx > 0"
                                class="w-full flex items-center gap-3 px-4 py-3 text-sm font-semibold rounded-xl transition-colors text-[color:var(--muted-foreground)] hover:bg-[color:var(--hover)] hover:text-[color:var(--primary)] border border-transparent border-[color:var(--border)]"
                            >
                                <lucide-icon [name]="item.icon" class="h-5 w-5 text-current opacity-80"></lucide-icon>
                                <span class="flex-1 text-left">{{ item.name }}</span>
                                <lucide-icon [name]="isGroupExpanded(item.name) ? 'chevron-down' : 'chevron-right'" class="h-4 w-4 text-current opacity-70"></lucide-icon>
                            </button>
                            <ng-container *ngIf="isGroupExpanded(item.name)">
                                <a
                                    *ngFor="let child of item.children"
                                    [routerLink]="child.href"
                                    [ngClass]="navActiveClasses(child.href)"
                                    class="flex items-center gap-3 pl-10 pr-4 py-3 text-sm font-semibold rounded-xl transition-colors text-[color:var(--muted-foreground)] hover:bg-[color:var(--hover)] hover:text-[color:var(--primary)] border border-transparent"
                                    (click)="closeMobile()"
                                >
                                    <lucide-icon [name]="child.icon" class="h-5 w-5 text-current opacity-80"></lucide-icon>
                                    {{ child.name }}
                                </a>
                            </ng-container>
                        </ng-container>
                        <!-- Non-collapsible group (heading + always-visible children) -->
                        <ng-container *ngIf="!isCollapsible(item) && item.children?.length">
                            <p
                                [class.mt-6]="idx > 0"
                                [class.pt-4]="idx > 0"
                                [class.border-t]="idx > 0"
                                class="px-3 text-[11px] font-semibold uppercase tracking-wide text-[color:var(--text-subtle)] border-[color:var(--border)]"
                            >
                                {{ item.name }}
                            </p>
                            <ng-container *ngFor="let child of item.children">
                                <a
                                    [routerLink]="child.href"
                                    [ngClass]="navActiveClasses(child.href)"
                                    class="flex items-center gap-3 px-4 py-3 text-sm font-semibold rounded-xl transition-colors text-[color:var(--muted-foreground)] hover:bg-[color:var(--hover)] hover:text-[color:var(--primary)] border border-transparent"
                                    (click)="closeMobile()"
                                >
                                    <lucide-icon [name]="child.icon" class="h-5 w-5 text-current opacity-80"></lucide-icon>
                                    {{ child.name }}
                                </a>
                            </ng-container>
                        </ng-container>
                        <!-- Leaf link -->
                        <ng-container *ngIf="!isCollapsible(item) && !item.children?.length">
                            <a
                                [routerLink]="item.href"
                                [ngClass]="navActiveClasses(item.href)"
                                class="flex items-center gap-3 px-4 py-3 text-sm font-semibold rounded-xl transition-colors text-[color:var(--muted-foreground)] hover:bg-[color:var(--hover)] hover:text-[color:var(--primary)] border border-transparent"
                                (click)="closeMobile()"
                            >
                                <lucide-icon [name]="item.icon" class="h-5 w-5 text-current opacity-80"></lucide-icon>
                                {{ item.name }}
                            </a>
                        </ng-container>
                    </ng-container>
                </nav>
            </aside>
        </div>
    </div>

    <aside class="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:inset-y-0 bg-[color:var(--card)] text-[color:var(--foreground)] border-r border-[color:var(--border)] shadow-[0_20px_50px_rgba(15,23,42,0.08)]">
        <a routerLink="/" class="flex items-center gap-3 h-16 px-6 border-b border-[color:var(--border)] hover:bg-[color:var(--hover)] transition-colors">
            <div class="h-10 px-3 flex items-center">
                <img [src]="logoSrc" alt="nibni" class="h-10 w-auto object-contain select-none" />
            </div>
        </a>
        <nav class="custom-scrollbar min-h-0 flex-1 px-4 py-6 space-y-2 overflow-y-auto overscroll-contain">
            <ng-container *ngFor="let item of navigation; let idx = index">
                <!-- Collapsible dropdown (e.g. "More") -->
                <ng-container *ngIf="isCollapsible(item)">
                    <button
                        type="button"
                        (click)="toggleGroup(item.name)"
                        [attr.aria-expanded]="isGroupExpanded(item.name)"
                        [class.mt-6]="idx > 0"
                        [class.pt-4]="idx > 0"
                        [class.border-t]="idx > 0"
                        class="w-full flex items-center gap-3 px-4 py-3 text-sm font-semibold rounded-xl transition-colors text-[color:var(--muted-foreground)] hover:bg-[color:var(--hover)] hover:text-[color:var(--primary)] border border-transparent border-[color:var(--border)]"
                    >
                        <lucide-icon [name]="item.icon" class="h-5 w-5 text-current opacity-80"></lucide-icon>
                        <span class="flex-1 text-left">{{ item.name }}</span>
                        <lucide-icon [name]="isGroupExpanded(item.name) ? 'chevron-down' : 'chevron-right'" class="h-4 w-4 text-current opacity-70"></lucide-icon>
                    </button>
                    <ng-container *ngIf="isGroupExpanded(item.name)">
                        <a
                            *ngFor="let child of item.children"
                            [routerLink]="child.href"
                                    [ngClass]="navActiveClasses(child.href)"
                            class="flex items-center gap-3 pl-10 pr-4 py-3 text-sm font-semibold rounded-xl transition-colors text-[color:var(--muted-foreground)] hover:bg-[color:var(--hover)] hover:text-[color:var(--primary)] border border-transparent"
                        >
                            <lucide-icon [name]="child.icon" class="h-5 w-5 text-current opacity-80"></lucide-icon>
                            {{ child.name }}
                        </a>
                    </ng-container>
                </ng-container>
                <!-- Non-collapsible group (heading + always-visible children) -->
                <ng-container *ngIf="!isCollapsible(item) && item.children?.length">
                    <p
                        [class.mt-6]="idx > 0"
                        [class.pt-4]="idx > 0"
                        [class.border-t]="idx > 0"
                        class="px-3 text-[11px] font-semibold uppercase tracking-wide text-[color:var(--text-subtle)] border-[color:var(--border)]"
                    >
                        {{ item.name }}
                    </p>
                    <ng-container *ngFor="let child of item.children">
                        <a
                            [routerLink]="child.href"
                                    [ngClass]="navActiveClasses(child.href)"
                            class="flex items-center gap-3 px-4 py-3 text-sm font-semibold rounded-xl transition-colors text-[color:var(--muted-foreground)] hover:bg-[color:var(--hover)] hover:text-[color:var(--primary)] border border-transparent"
                        >
                            <lucide-icon [name]="child.icon" class="h-5 w-5 text-current opacity-80"></lucide-icon>
                            {{ child.name }}
                        </a>
                    </ng-container>
                </ng-container>
                <!-- Leaf link -->
                <ng-container *ngIf="!isCollapsible(item) && !item.children?.length">
                    <a
                        [routerLink]="item.href"
                                [ngClass]="navActiveClasses(item.href)"
                        class="flex items-center gap-3 px-4 py-3 text-sm font-semibold rounded-xl transition-colors text-[color:var(--muted-foreground)] hover:bg-[color:var(--hover)] hover:text-[color:var(--primary)] border border-transparent"
                    >
                        <lucide-icon [name]="item.icon" class="h-5 w-5 text-current opacity-80"></lucide-icon>
                        {{ item.name }}
                    </a>
                </ng-container>
            </ng-container>
        </nav>
    </aside>
    
